/** Load an image for canvas use (object URL or URL). */
function loadImage(src: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error("Failed to load image"));
    img.src = src;
  });
}

const AVATAR_EXPORT_SIZE = 512;

export type PixelCrop = { x: number; y: number; width: number; height: number };

/**
 * Renders the cropped square from the source image into a square canvas and returns a Blob.
 * `area` must be `croppedAreaPixels` from react-easy-crop (natural image coordinates).
 */
export async function blobFromCroppedImage(
  imageSrc: string,
  area: PixelCrop,
  mimeType: string = "image/jpeg",
  quality = 0.9,
): Promise<Blob> {
  const image = await loadImage(imageSrc);
  const canvas = document.createElement("canvas");
  canvas.width = AVATAR_EXPORT_SIZE;
  canvas.height = AVATAR_EXPORT_SIZE;
  const ctx = canvas.getContext("2d");
  if (!ctx) throw new Error("Could not get canvas context");
  ctx.imageSmoothingEnabled = true;
  ctx.imageSmoothingQuality = "high";
  ctx.drawImage(
    image,
    area.x,
    area.y,
    area.width,
    area.height,
    0,
    0,
    AVATAR_EXPORT_SIZE,
    AVATAR_EXPORT_SIZE,
  );
  const outType = mimeType === "image/png" ? "image/png" : "image/jpeg";
  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (b) => (b ? resolve(b) : reject(new Error("Export failed"))),
      outType,
      outType === "image/png" ? undefined : quality,
    );
  });
}
